import { LuPencilLine, LuTrash2 } from "react-icons/lu";
import SelectionActionBar from "../../../common/SelectionActionBar";

export default function SuppliersActionBar({
  selectedCount,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  onClear,
}) {
  const actions = [
    canEdit && { key: "edit", label: "Edit", icon: LuPencilLine, onClick: onEdit },
    canDelete && { key: "delete", label: "Delete", icon: LuTrash2, onClick: onDelete, danger: true },
  ];

  return (
    <SelectionActionBar
      selectedCount={selectedCount}
      actions={actions}
      onClear={onClear}
    />
  );
}